import React, { useEffect } from "react";
import PageWrapper from "./PageWrapper";

const navigateToCompletion = (url) => window.location.assign(url);

const ThankYouPage = ({ completion, navigate = navigateToCompletion }) => {
  const isProlific = completion?.source === "prolific";
  const redirectReady = isProlific
    && completion?.configurationStatus === "ready"
    && completion?.redirectAvailable === true
    && typeof completion?.redirectUrl === "string";

  useEffect(() => {
    if (!redirectReady) return undefined;
    const timer = window.setTimeout(
      () => navigate(completion.redirectUrl),
      completion.autoRedirectDelayMs
    );
    return () => window.clearTimeout(timer);
  }, [completion?.autoRedirectDelayMs, completion?.redirectUrl, navigate, redirectReady]);

  let secondParagraph = "You may now close this page.";
  if (isProlific && redirectReady) {
    secondParagraph = "You will now be redirected to Prolific to confirm your completion.";
  } else if (isProlific) {
    secondParagraph = "We could not return you to Prolific automatically. Please keep this page open and contact the researcher.";
  }

  return (
    <PageWrapper>
      <main style={{ maxWidth: "700px", margin: "0 auto", textAlign: "center", padding: "var(--spacing-xxl)" }}>
        <div
          style={{
            backgroundColor: "var(--color-success-light)",
            padding: "var(--spacing-xxl)",
            borderRadius: "var(--radius-xl)",
            border: "2px solid var(--color-success)",
          }}
          role="status"
          aria-live="polite"
        >
          <div style={{ fontSize: "64px", marginBottom: "1rem" }} aria-hidden="true">✅</div>
          <h1 style={{ color: "var(--color-success)", marginBottom: "1.5rem" }}>
            Thank you for taking part
          </h1>
          <p>You have completed the study, and your responses have been saved successfully.</p>
          <p>{secondParagraph}</p>

          {redirectReady && (
            <>
              <button
                type="button"
                onClick={() => navigate(completion.redirectUrl)}
                className="btn btn-primary"
                data-testid="thank-you-return-to-prolific"
                style={{ minWidth: "250px", minHeight: "56px", marginTop: "1rem" }}
              >
                Return to Prolific
              </button>
              <p>If the redirect does not happen automatically, select the button above.</p>
            </>
          )}
        </div>
      </main>
    </PageWrapper>
  );
};

export default ThankYouPage;
